import React from 'react'

import SearchEmployees from '/react4xp/components/pages/search-employees'

function SearchEmployeesPart(props: any) {
    return (
        <SearchEmployees {...props} />
    )
}

export default (props) => <SearchEmployeesPart {...props} />
